module.exports = __webpack_public_path__ + "static/media/clay.46c3d49e.jpeg";